// FeatureCard.js
import React from 'react';
import { Link } from 'react-router-dom';

function FeatureCard({ backgroundImage, title, buttonText, linkUrl }) {
  return (
    <div
      className="feature-card"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="overlay" />
      <div className="content">
        <h2>{title}</h2>
        <Link to={linkUrl}>
          <button type="button">{buttonText}</button>
        </Link>
      </div>
    </div>
  );
}

export default FeatureCard;
